export default "__VITE_ASSET__Bcb5iXFz__"